
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.89637 6.5H5.7297C5.3619 6.50181 5.0097 6.64725 4.74962 6.90472C4.48955 7.1622 4.34263 7.51088 4.34081 7.875V12.275C4.34263 12.6391 4.48955 12.9878 4.74962 13.2453C5.0097 13.5027 5.3619 13.6482 5.7297 13.65H9.61859V13.925C9.61676 14.435 9.41131 14.9236 9.04705 15.2842C8.68279 15.6448 8.18928 15.8482 7.67414 15.85C7.45313 15.85 7.24117 15.9369 7.08489 16.0916C6.92861 16.2464 6.84081 16.4562 6.84081 16.675C6.84081 16.8938 6.92861 17.1036 7.08489 17.2584C7.24117 17.4131 7.45313 17.5 7.67414 17.5C8.14836 17.5 8.61793 17.4075 9.05606 17.2279C9.49418 17.0482 9.89226 16.7849 10.2276 16.4529C10.5629 16.1209 10.8289 15.7268 11.0104 15.2931C11.1918 14.8594 11.2853 14.3945 11.2853 13.925V7.875C11.2834 7.51088 11.1365 7.1622 10.8764 6.90472C10.6164 6.64725 10.2642 6.50181 9.89637 6.5ZM9.61859 12H6.00748V8.15H9.61859V12ZM17.9519 6.5H13.7853C13.4175 6.50181 13.0653 6.64725 12.8052 6.90472C12.5451 7.1622 12.3982 7.51088 12.3964 7.875V12.275C12.3982 12.6391 12.5451 12.9878 12.8052 13.2453C13.0653 13.5027 13.4175 13.6482 13.7853 13.65H17.6741V13.925C17.6723 14.435 17.4669 14.9236 17.1026 15.2842C16.7383 15.6448 16.2448 15.8482 15.7297 15.85C15.5087 15.85 15.2967 15.9369 15.1404 16.0916C14.9842 16.2464 14.8964 16.4562 14.8964 16.675C14.8964 16.8938 14.9842 17.1036 15.1404 17.2584C15.2967 17.4131 15.5087 17.5 15.7297 17.5C16.6874 17.5 17.6059 17.1233 18.2831 16.4529C18.9604 15.7825 19.3408 14.8731 19.3408 13.925V7.875C19.339 7.51088 19.1921 7.1622 18.932 6.90472C18.6719 6.64725 18.3197 6.50181 17.9519 6.5ZM17.6741 12H14.063V8.15H17.6741V12Z","fill":"#10001F"}})])
          )
        }
      }
    